/*!
 * Stimpack Control - Column Sizes
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlColumnBreakpoints = function(root, options)
    {
        var _this = this,
            root = $(root);

        this.options = $.extend({
            name        : '',
            selectors   : {
                breakpoint      : '.sp-control-column-breakpoint',
                width           : '.sp-control-column-breakpoint-width-control',
                customWidth     : '.sp-control-column-breakpoint-custom-width-control',
                offset          : '.sp-control-column-breakpoint-offset-control',
                customOffset    : '.sp-control-column-breakpoint-custom-offset-control',
                visibility      : '.sp-control-column-breakpoint-visibility-control',
                encodedOutput    : '.sp-control-column-breakpoints-encoded-output'
            }
        }, options);

        this.el = {
            root        : root,
            encodedOutput  : root.find(this.options.selectors.encodedOutput)
        };

        this.init();
    };

    /*
     * Get Terms
     */
    spControlColumnBreakpoints.prototype.init = function()
    {
        var _this = this;

        this.el.root.on('change', this.options.selectors.width, function() {
            _this.refreshCustomControls('width');
        });

        this.el.root.on('change', this.options.selectors.offset, function() {
            _this.refreshCustomControls('offset');
        });

        this.el.root.on('change', this.options.selectors.visibility, function() {
            _this.refresh();
        });

        this.initPlaceholders();
    };

    /*
     * Init placeholders
     */
    spControlColumnBreakpoints.prototype.initPlaceholders = function()
    {
        var _this = this,
            controls = this.el.root.find('[name*="' + this.options.name + '"][placeholder]');

        if (controls.length > 0)
        {
            controls.each(function() {

                var control = $(this),
                    placeholder = control.attr('placeholder');

                control.data('sp-origin-placeholder', placeholder);
            });
        }
    }

    /*
     * Get value
     */
    spControlColumnBreakpoints.prototype.getValue = function()
    {
        var json = this.el.root.find('[name' + (this.options.name ? '*="' + this.options.name + '"' : '') + ']:not(' + this.options.selectors.encodedOutput + ')').serializeJSON({useIntKeysAsArrayIndex: false});

        if (typeof json === 'object')
        {
            if (typeof json[this.options.name] === 'object')
            {
                json = json[this.options.name];
            }
            else if (typeof json.acf === 'object')
            {
                json = json.acf;
                json = json[Object.keys(json)[0]];
            }

            return json;
        }
    };

    /*
     * Refresh
     */
    spControlColumnBreakpoints.prototype.refresh = function()
    {
        this.refreshPlaceholders('width', '-'); //TODO get default placeholder from options
        this.refreshPlaceholders('offset', '-'); //TODO get default placeholder from options
        this.refreshPlaceholders('visibility', 'Visible'); //TODO get default placeholder from options

        this.updateJsonOutput();
    }


    /*
     * Refresh placeholders
     */
    spControlColumnBreakpoints.prototype.refreshPlaceholders = function(name, defaultValue)
    {
        var _this = this,
            controls = this.el.root.find('[name*="[' + name + ']"]'),
            lastValue = null;

        if (controls.length > 0)
        {
            controls.each(function(index) {

                var control = $(this),
                    value = control.find('option:selected').val(),
                    fallbackValue = control.data('sp-fallback-value') || null,
                    placeholder = defaultValue;

                if (null !== value && '' !== value)
                {
                    lastValue = value;
                }
                else if (null !== fallbackValue && '' !== fallbackValue)
                {
                    lastValue = fallbackValue;
                }

                if (lastValue)
                {
                    placeholder = control.find('option[value="' + lastValue + '"]').text();
                }

                control.next("span.select2:first").find("span.select2-selection__placeholder").html(placeholder);
                control.data('select2').selection.placeholder.text = placeholder;
            });
        }
    }

    /*
     * Refresh custom controls
     */
    spControlColumnBreakpoints.prototype.refreshCustomControls = function(name)
    {
        var _this = this,
            controls = this.el.root.find(this.options.selectors[name]),
            count = 0;

        if (controls.length > 0)
        {
            controls.each(function() {

                var control = $(this),
                    breakpoint = control.closest(_this.options.selectors.breakpoint),
                    selected = control.find('[value="custom"]').is(':selected') ? 1 : 0;

                count += selected;
                breakpoint[selected > 0 ? 'addClass' : 'removeClass']('sp-control-column-breakpoint-has-custom-' + name + '-selected');
            });
        }

        this.el.root[count > 0 ? 'addClass' : 'removeClass']('sp-control-column-breakpoints-has-custom-' + name + '-selected');

        this.refresh();
    }

    /*
     * Update json output
     */
    spControlColumnBreakpoints.prototype.updateJsonOutput = function()
    {
        if (this.el.encodedOutput.length > 0)
        {
            var value = this.getValue();

            console.log(value);

            if (value)
            {
                $.each(value, function(i, item) {

                    /*if (!item.id && !item.content)
                    {
                        delete value[i];
                    }*/
                });
            }

            //value = typeof value === 'object' ? spBase64Encode(JSON.stringify(value)) : null;
            //this.el.encodedOutput.val(value);
        }
    }

    $.fn.spControlColumnBreakpoints = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-column-breakpoints');

            $(this).attr('data-sp-control-column-breakpoints', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlColumnBreakpoints = new spControlColumnBreakpoints(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-column-breakpoints]').each(function() {
        $(this).spControlColumnBreakpoints();
    });

})(jQuery);
